module.exports = __webpack_public_path__ + "img/img_smart_banner.33e635c7.png";